module.exports = __webpack_public_path__ + "static/media/imgparkrun01.c7c6e340.jpg";